import { Box, Typography, styled } from "@mui/material";

import NumberFormats from "components/NumberFormats";

function WrapperAverageBuy({ data }) {
  return (
    <BoxWrapper>
      <Box display="flex" marginBottom={2}>
        <Typography
          variant="h6"
          component="span"
          color="success.main"
          fontWeight={600}
        >
          <NumberFormats value={data?.buyFilled} />
        </Typography>
        <Typography
          variant="h6"
          component="span"
          color="success.main"
          marginLeft={1}
        >
          {data?.name}
        </Typography>
      </Box>

      <BoxStyle>
        <Box>
          <Typography
            variant="h6"
            component="span"
            color="text.main"
            fontWeight={600}
            marginLeft={1}
          >
            <NumberFormats value={data?.buyAvgUSDT} />
          </Typography>
          <Typography variant="h6" component="span" marginLeft={1}>
            USDT
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="h6"
            component="span"
            color="text.main"
            fontWeight={600}
            marginLeft={1}
          >
            <NumberFormats value={data?.buyAvgToman} />
          </Typography>
          <Typography variant="h6" component="span" marginLeft={1}>
            TOMAN
          </Typography>
        </Box>
      </BoxStyle>
    </BoxWrapper>
  );
}

const BoxStyle = styled(Box)(({ theme }) => ({
  borderLeft: `2px solid ${theme.palette.success.main}`,
}));

const BoxWrapper = styled(Box)(() => ({
  cursor: "pointer",
}));
export default WrapperAverageBuy;
